import { useQuery } from '@tanstack/react-query';
import { api, GrGameConfigDetail } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseGameConfigsReturn {
  gameConfigs: GrGameConfigDetail[];
  total: number;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useGameConfigs(): UseGameConfigsReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.gameConfigs(),
    queryFn: () => api.listGameRewardsGames(),
    staleTime: 5 * 60 * 1000, // Game configs are admin-controlled, rarely change
  });

  return {
    gameConfigs: data?.gameConfigs ?? [],
    total: data?.total ?? 0,
    loading: isLoading,
    error: error instanceof Error ? error.message : isError ? 'Failed to load game configs' : null,
    refresh: () => {
      refetch();
    },
  };
}
